// extracted by mini-css-extract-plugin
export default {"footer":"DrawerFooter_footer__WcJmU"};